import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { twMerge } from "tailwind-merge";

const DatePickerComponent = ({ mode, selected, onSelect, disabledPeriod }) => {
  return (
    <div className=" px-5 py-4 w-fit text-black rounded-[10px] shadow-[0_10px_30px_0_#8311B326]">
      <DayPicker
        mode={mode ?? "single"}
        selected={selected}
        onSelect={onSelect}
        disabledPeriod={(date) => disabledPeriod(date)}
        classNames={{
          months:
            "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0 text-black",
          month: "space-y-4",
          caption: "flex justify-start pt-1 relative items-center",
          caption_label: "text-base font-semibold ",
          nav: "space-x-1 flex items-center ml-auto",
          nav_button: twMerge(
            "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
          ),
          nav_button_previous: "absolute left-1",
          nav_button_next: "absolute right-1",
          table: "w-full border-collapse space-y-1",
          head_row: "flex gap-2",
          head_cell:
            "text-neutral-500 rounded-md w-9 font-normal text-[0.8rem] dark:text-neutral-400",
          row: "flex w-full mt-2 gap-1.5",
          //   cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-neutral-100/50 [&:has([aria-selected])]:bg-neutral-100 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20 dark:[&:has([aria-selected].day-outside)]:bg-neutral-800/50 dark:[&:has([aria-selected])]:bg-neutral-800",
          day: twMerge(
            "h-9 w-9 p-0 font-normal aria-selected:opacity-100 !border !border-[#F0F2F5] rounded-[10px] !text-xs hover:!bg-[#FBF2FF] duration-300"
          ),
          day_range_start: "!border !border-purpleBg !outline-none",
          day_range_end: "!border !border-purpleBg !outline-none",
          day_selected:
            "bg-app-primary text-neutral-50 hover:bg-app-primary hover:text-neutral-50 focus:bg-app-primary focus:text-neutral-50 dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-50 dark:hover:text-neutral-900 dark:focus:bg-neutral-50 dark:focus:text-neutral-900 !bg-[#FBF2FF] !text-black",
          day_today:
            "bg-neutral-100 text-neutral-900 dark:bg-neutral-800 dark:text-neutral-50",
          day_outside:
            "day-outside text-neutral-500 opacity-50 aria-selected:bg-neutral-100/50 aria-selected:text-neutral-500 aria-selected:opacity-30 dark:text-neutral-400 dark:aria-selected:bg-neutral-800/50 dark:aria-selected:text-neutral-400",
          day_disabled:
            "text-neutral-500 opacity-50 !bg-[##F7F9FC] !text-[#D0D5DD]",
          day_range_middle:
            "aria-selected:bg-neutral-100 aria-selected:text-neutral-900 dark:aria-selected:bg-neutral-800 dark:aria-selected:text-neutral-50",
          day_hidden: "invisible",
          caption_dropdowns: "flex w-full justify-around",
          dropdown_month:
            "[&>span]:hidden [&>select]:outline-none [&>select]:p-1 [&>select]:bg-neutral-100 [&>select]:rounded-md",
          //   dropdown_year:
          //     "[&>span]:hidden [&>select]:outline-none [&>select]:p-1 [&>select]:bg-neutral-100 [&>select]:rounded-md",

          //   ...classNames,
        }}
      />
    </div>
  );
};

export default DatePickerComponent;
